// extracted by css-extract-rspack-plugin
export default {"main":"ySbWh","resizing":"RzGFB"};